export const METADATA_SHEET_FIXED_HEADERS = ["size", "language", "reportingLabel"] as const;

export type MetadataSheetFixedHeader = (typeof METADATA_SHEET_FIXED_HEADERS)[number];

export const METADATA_SHEET_FIXED_COLUMN_COUNT = METADATA_SHEET_FIXED_HEADERS.length;

export const MetadataSheetColumnPosition = {
    size: METADATA_SHEET_FIXED_HEADERS.indexOf("size"),
    language: METADATA_SHEET_FIXED_HEADERS.indexOf("language"),
    reportingLabel: METADATA_SHEET_FIXED_HEADERS.indexOf("reportingLabel")
} as const;

export const METADATA_SHEET_NAME = "Deliverables";
